export const MenuItemDesign = Object.freeze({
	Default: 'default',
	Accent1: 'accent-1',
	Accent2: 'accent-2',
	Alert: 'alert',
	Copilot: 'copilot',
	Disabled: 'disabled',
});

export const MenuSectionDesign = Object.freeze({
	Default: 'default',
	Accent: 'accent',
});

export const MenuRichHeaderDesign = Object.freeze({
	Default: 'default',
	Copilot: 'copilot',
});
